import React, { useEffect, useState } from 'react';

const OfflineBanner: React.FC = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => setIsOffline(false);

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[9999] bg-orange-500 text-white text-center py-2 text-sm font-medium shadow-md"
      dir="rtl"
    >
      📶 أنت غير متصل بالإنترنت — بعض الميزات قد لا تعمل
    </div>
  );
};

export default OfflineBanner;
